/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_AudiobookInputs */

const en_val_audiobook = /** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobook`)
};

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const es_val_audiobook = en_val_audiobook;

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const fr_val_audiobook = en_val_audiobook;

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const de_val_audiobook = en_val_audiobook;

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const ja_val_audiobook = en_val_audiobook;

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const zh_val_audiobook = en_val_audiobook;

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const ar_val_audiobook = en_val_audiobook;

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const id_val_audiobook = en_val_audiobook;

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const it_val_audiobook = en_val_audiobook;

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const ru_val_audiobook = en_val_audiobook;

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const pt_val_audiobook = en_val_audiobook;

/** @type {(inputs: Val_AudiobookInputs) => LocalizedString} */
const ko_val_audiobook = en_val_audiobook;

/**
* | output |
* | --- |
* | "Audiobook" |
*
* @param {Val_AudiobookInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_audiobook = /** @type {((inputs?: Val_AudiobookInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_AudiobookInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_audiobook(inputs)
	if (locale === "es") return es_val_audiobook(inputs)
	if (locale === "fr") return fr_val_audiobook(inputs)
	if (locale === "de") return de_val_audiobook(inputs)
	if (locale === "ja") return ja_val_audiobook(inputs)
	if (locale === "zh") return zh_val_audiobook(inputs)
	if (locale === "ar") return ar_val_audiobook(inputs)
	if (locale === "id") return id_val_audiobook(inputs)
	if (locale === "it") return it_val_audiobook(inputs)
	if (locale === "ru") return ru_val_audiobook(inputs)
	if (locale === "pt") return pt_val_audiobook(inputs)
	return ko_val_audiobook(inputs)
});